module.exports = __webpack_public_path__ + "media/country_flags/vn-816babe3.png";